import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import Layout from './components/Layout.vue';

import '@/styles/index.scss';
import BaiduMap from 'vue-baidu-map';

Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: 'YRTAEe71aVkC2I43hoo7QmHi4zjIG90q',
});

const list = [
  '/Cart',
  '/PersonalInformation',
  '/Payment',
  '/afterSales',
  '/orderDetail',
  '/resetPassword',
];
router.beforeEach((to, form, next) => {
  const token = localStorage.getItem('token');
  if (list.includes(to.path) && !token) {
    next({ path: '/Login' });
  } else {
    next();
  }
});

new Vue({
  el: '#app',
  router,
  render: (h) => h(Layout),
});
